export const ProductDtDemoData = {
    id: 'abcd',
    applicationType: '',
    applicationTitle: 'Envision Pulse',
    description: 'Omni-channel API access for Email, SMS, and Line communication.',
    logoUrl: 'https://miracleadvance.com/wp-content/uploads/2023/09/pulse.svg',
    website: 'https://miracleadvance.com/envision-pulse/',
    status: 'active',
    demo: true,
    packages: [
        {
            id: 'abcd',
            applicationId: 20,
            packageName: 'Advance Package',
            limitBy: 'ppu',
            role: 'customer',
            priority: 0,
            addons: [
                {
                    id: 43,
                    appServiceId: 1,
                    appServicePackageId: 6,
                    serviceTitle: 'Installation',
                    servicePackageName: 'Remote Installation Service\t',
                    currency: 'USD',
                    amount: -102,
                    vatPercent: 0,
                    priority: 0,
                    status: 'active',
                    demo: true
                }
            ],
            prices: [
                {
                    id: 2,
                    currency: 'usd',
                    amount: 500,
                    vatPercent: 20,
                    priority: 0,
                    limitByValue: 0,
                    packageUnitName: '',
                    limitByPPU: 100,
                    status: 'active',
                    demo: true
                }
            ],
            pricing: [
                {
                    id: 1,
                    currency: 'USD',
                    amount: 40000,
                    vatPercent: 0,
                    limitByValue: 0,
                    packageUnitName: 'yearly',
                    priority: 0,
                    status: 'inactive',
                    timeCreated: 1759213410,
                    demo: true
                }
            ],
            status: 'active',
            demo: true
        }
    ]
};

export default null;
